export default __webpack_public_path__ + "static/eco_packaging-33567955a5cbd975c8dde49bf5fac2f4.svg";